module.exports = __webpack_public_path__ + "resources/img/img_datahunt1.e404418d558ea92f85792e6be8fa3068.png";